module.exports = __webpack_public_path__ + "static/media/ticketing.9f29cd49.svg";